/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userPinResetWithVerificationCode

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userPinResetWithVerificationCode.UserPinResetApi

import features.userPinResetWithVerificationCode.serializeUserPinResetState
import kangaroorewards.appsdk.core.io.EmptyResponse



/**
 * Reset a customer PIN. Requires both a verification code and either a phone number or email address  [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserPinResetApi")
class UserPinResetApiJs {

    /**
     * Reset a customer PIN. Requires both a verification code and either a phone number or email address 
     */
    fun resetPin(
        overrideHeaders: String?, 
        verificationCode: String,
        pinCode: String,
        email: String? = null,
        phone: String? = null,
        countryCode: String? = null
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserPinResetApi().resetPin(
            overrideHeaders = decodedOverrideHeaders,
                        verificationCode = verificationCode,
            pinCode = pinCode,
            email = email,
            phone = phone,
            countryCode = countryCode
        ).toJsonResult<EmptyResponse>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserPinResetState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserPinResetApi().userPinResetState.serializeUserPinResetState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.EmptyResponse -> onData(Json.encodeToString(EmptyResponse.serializer(), EmptyResponse))
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
